export const LEVELS = ['trace', 'debug', 'info', 'warn', 'error', 'fatal'] as const;

export type Level = (typeof LEVELS)[number];

// OpenTelemetry's severity numbers, the first of each range: `level:>=warn` compares these.
export const SEVERITY: Readonly<Record<Level, number>> = { trace: 1, debug: 5, info: 9, warn: 13, error: 17, fatal: 21 };

// Every spelling a logger or a person uses for a level: winston's npm levels (bustard), syslog's, the usual short forms.
const ALIASES: Readonly<Record<string, Level>> = {
    silly: 'trace',
    trace: 'trace',
    verbose: 'debug',
    debug: 'debug',
    dbg: 'debug',
    http: 'info',
    info: 'info',
    information: 'info',
    notice: 'info',
    log: 'info',
    warn: 'warn',
    warning: 'warn',
    wrn: 'warn',
    error: 'error',
    err: 'error',
    fatal: 'fatal',
    critical: 'fatal',
    crit: 'fatal',
    alert: 'fatal',
    emerg: 'fatal',
    emergency: 'fatal',
    panic: 'fatal',
};

export function levelOf(raw: unknown): Level | null {
    return typeof raw === 'string' ? (ALIASES[raw.trim().toLowerCase()] ?? null) : null;
}
